<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item
        ><router-link to="/">首页</router-link></el-breadcrumb-item
      >
      <el-breadcrumb-item>结果类型</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form
        inline
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="selClick"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>结果列表</span></div>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column
            prop="sort"
            label="排序"
            width="70"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="名称"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="code"
            label="代号"
            min-width="60"
          ></el-table-column>
          <el-table-column
            prop="result"
            label="特点描述"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="major"
            label="推荐专业"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="work"
            label="推荐职业方向"
            min-width="120"
          ></el-table-column>

          <el-table-column label="雷达显示" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isRadar" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否可用" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="form.id > 0 ? '编辑资料' : '添加资料'"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        @submit.native.prevent="submitForm"
      >
        <el-form-item
          label="标题"
          prop="title"
          :rules="[{ required: true, message: '请输入标题' }]"
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item
          label="代号"
          prop="code"
          :rules="[{ required: true, message: '请输入代号' }]"
        >
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="特点描述"
          ><el-input v-model="form.result" type="textarea" :rows="2"></el-input
        ></el-form-item>
        <el-form-item label="推荐专业"
          ><el-input v-model="form.major" type="textarea" :rows="2"></el-input
        ></el-form-item>
        <el-form-item label="推荐职业方向"
          ><el-input v-model="form.work" type="textarea" :rows="2"></el-input
        ></el-form-item>
        <el-row :gutter="16">
          <el-col :span="8"
            ><el-form-item label="排序" :rules="[{ required: true }]"
              ><el-input v-model.number="form.sort"></el-input></el-form-item
          ></el-col>
          <el-col :span="8"
            ><el-form-item label="雷达显示" :rules="[{ required: true }]"
              ><el-switch v-model="form.isRadar"></el-switch></el-form-item
          ></el-col>
          <el-col :span="8"
            ><el-form-item label="启用" :rules="[{ required: true }]"
              ><el-switch v-model="form.isEnable"></el-switch></el-form-item
          ></el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key: "",
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      submiting: false,
      form: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    api(a) {
      return url.getMiniCategoryAndStudyPlan(a);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    selClick() {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      $.get(
        this.api("GetList_Category"),
        {
          key: this.key,
          pageindex: this.currentPage,
          pagesize: this.pageSize,
        },
        (data) => {
          this.loading = false;
          this.tableData = data.list;
          this.total = data.total;
        },
      );
    },
    addClick() {
      this.form = {};
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    editClick(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          $.post(this.api("Delete_Category"), { id: row.id }, (res) => {
            if (res.status) {
              this.getList();
              this.$message.success(res.msg);
            } else this.$message.error(res.msg);
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const info = Object.assign({}, this.form);
        this.submiting = true;
        $.post(this.api("Save_Category"), info, (res) => {
          this.submiting = false;
          if (res.status) {
            this.dialogVisible = false;
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      });
    },
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>
